export enum PERMISSIONS {
    CREATE = 'CREATE',
}
export default class Permissions {
    constructor(readonly create: boolean) {}
}
